import { useContext, useEffect, useRef, useMemo } from "react";

// Utils
import { format, getCloudinaryUrl, getNestedValue } from "@swiggy-private/js-utils";

// Constants
import {
    GRATIFICATION_HALF_CARD_LOTTIE,
    GRATIFICATION_HALF_CARD_LOTTIE_ASSETS,
    HALF_CARD_LOTTIE_IMAGES_ASSET_COUNT,
    VARIANT,
} from "@swiggy-private/super-ui";
import { CartContext } from "@cart-client/contexts/CartContext";

export const usePrefetchPlanRemovalLottie = () => {
    const planRemovalLottieImagesFetchRef = useRef<boolean>(false);
    const planRemovalLottieFetchRef = useRef<boolean>(false);
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;
    const variant = useMemo(
        () => getNestedValue(cartResponse, "data.swiggyOneInfo.presentationInfo.remove_plan_message.variant", ""),
        [cartResponse],
    );
    const shouldPrefetch = useMemo(() => variant === VARIANT.ANIMATION, [variant]);

    useEffect(() => {
        if (!shouldPrefetch) return;
        if (!planRemovalLottieImagesFetchRef.current) {
            const preFetchAllImages = async (): Promise<void> => {
                try {
                    const fetchPromises = [];
                    for (let i = 0; i <= HALF_CARD_LOTTIE_IMAGES_ASSET_COUNT; i++) {
                        const url = `${getCloudinaryUrl(format(GRATIFICATION_HALF_CARD_LOTTIE_ASSETS, i))}`;
                        fetchPromises.push(
                            fetch(url).catch(error => console.error(`Error fetching image ${url}:`, error)),
                        );
                    }
                    await Promise.all(fetchPromises);
                    planRemovalLottieImagesFetchRef.current = true;
                } catch (_err) {
                    //noop
                }
            };
            preFetchAllImages();
        }
        if (!planRemovalLottieFetchRef.current) {
            fetch(GRATIFICATION_HALF_CARD_LOTTIE || "")
                .then(() => {
                    planRemovalLottieFetchRef.current = true;
                })
                .catch();
        }
    }, [shouldPrefetch]);
};
